import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Solutions from "@/components/Solutions";
import WhyChooseUs from "@/components/WhyChooseUs";
import Industries from "@/components/Industries";
import CTA from "@/components/CTA";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <main className="relative bg-white">
      <Navbar />
      <Hero />
      <Marquee />
      <Solutions />
      <WhyChooseUs />
      <Industries />
      <CTA />
      <Footer />
    </main>
  );
}
